import { type, type Type } from "arktype";

import { ALL_SOURCES } from "@/components/people/source-badge";
import { pageInteger } from "@/lib/pagination";

export const fallback = <const def, t>(schema: Type<t>, def: def) =>
	[type("unknown").pipe((value) => (schema.allows(value) ? value : def)), "=", def] as const;

export const optional = <t>(schema: Type<t>) =>
	type("unknown").pipe((value) => (schema.allows(value) ? value : undefined));

export const pageParam = fallback(pageInteger, 1);

export const qParam = type("unknown").pipe((value) => {
	if (typeof value === "string") {
		return value;
	}

	if (typeof value === "number") {
		return String(value);
	}
});

export const sourceParam = optional(type.enumerated(...ALL_SOURCES));
